import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-plane",
  templateUrl: "./med-icon-plane.component.html",
})
export class MedIconPlaneComponent extends SvgMixinComponent {}
